import { Network } from '@yme/services/network';
export async function getData(endpoint) {
    const response = await Network.get(endpoint);
    return response.data;
}
